import { useId, useRef } from 'react';

export const Curve = ({
  fromRef,
  toRef,
  label,
  ...pathProps
}: {
  fromRef: React.RefObject<HTMLDivElement | null>;
  toRef: React.RefObject<HTMLDivElement | null>;

  label?: string;
} & React.JSX.IntrinsicElements['path']) => {
  const id = useId();
  const ref = useRef<SVGGElement | null>(null);
  if (!fromRef.current || !toRef.current) {
    return null;
  }

  const { left, top } = ref.current
    ?.closest('svg')
    ?.getBoundingClientRect() ?? {
    left: 0,
    top: 0,
  };

  const fromCoord = fromRef.current.getBoundingClientRect();
  const toCoord = toRef.current.getBoundingClientRect();

  const pointA = {
    x:
      fromCoord.left +
      (fromCoord.left < toCoord.left ? fromCoord.width : 0) -
      left,
    y: fromCoord.top + fromCoord.height / 2 - top,
  };

  const pointB = {
    x:
      toCoord.left + (fromCoord.left > toCoord.left ? toCoord.width : 0) - left,
    y: toCoord.top + toCoord.height / 2 - top,
  };

  const from = pointA.x < pointB.x ? pointA : pointB;
  const to = pointA.x < pointB.x ? pointB : pointA;

  return (
    <g ref={ref}>
      <path
        {...pathProps}
        id={id}
        d={`M${from.x} ${from.y}q${(to.x - from.x) / 4} 0, ${
          (to.x - from.x) / 2
        } ${(to.y - from.y) / 2} T${to.x}  ${to.y}`}
      />
      {!!label && (
        <text>
          <textPath
            href={`#${id}`}
            stroke="transparent"
            fill="white"
            textAnchor="middle"
            startOffset="50%"
            alignmentBaseline="after-edge"
          >
            {label}
          </textPath>
        </text>
      )}
    </g>
  );
};
